import React, { useEffect, useRef, useState } from "react";

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Login from "./Components/Pages/Login/Login";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "./Components/Pages/Bar/Sidebar";
import Navbar from "./Components/Pages/Bar/Navbar";

import "./App.css";
import Dashboard from "./Components/Pages/Dashboard/Dashboard";
import Patient from "./Components/Pages/Patient/Patient";
import MedicalForm from "./Components/Modal/PatientModal/MedicalForm";
import SectionScreen from "./Components/Pages/Fields&Sections/SectionScreen";
import ShowFields from "./Components/Pages/Fields&Sections/ShowFields";
import Doctor from "./Components/Pages/Doctor/Doctor";
import Surgery from "./Components/Pages/Surgery/Surgery";
import TypeSurgery from "./Components/Pages/Surgery/TypeSurgery";
import Organ from "./Components/Pages/Surgery/Organ";
import FollowUp from "./Components/Pages/Follow-Up/FollowUp";
import FollowUpVisit from "./Components/Pages/Follow-Up/FollowUpVisit";
import AffiarsOfSurgeryPage from "./Components/Pages/AffiarsOfSurgeryPage/AffiarsOfSurgeryPage";
import TypeOfHelp from "./Components/Pages/Surgery/TypeOfHelp";
import ComeBackDoctorPage from "./Components/Pages/ComeBackDoctorPage/ComeBackDoctorPage";
import WhatsAppScreen from "./Components/Pages/WhatsAppPage/WhatsAppScreen";
import TypeFieldPage from "./Components/Pages/Surgery/TypeFieldPage";
import TypeFieldDropdownValuePage from "./Components/Pages/Surgery/TypeFieldDropdownValuePage";
import MedicalSupliesPage from "./Components/Pages/MedicalSupliesPage/MedicalSupliesPage";
import RejectPage from "./Components/Pages/RejectPage/RejectPage";
import ReportPage from "./Components/Pages/Patient/Report/ReportPage";
import Users from "./Components/Pages/Users/Users";
import CreateUser from "./Components/Pages/Users/CreateUser";
import RolePage from "./Components/Pages/Previleges/RolePage";
import EditRolePage from "./Components/Pages/Previleges/EditRolePage";
import { getUsersAuthAction } from "./Components/Actions/UserAction/UserAction";
import StatisticsScreen from "./Components/Pages/StatisticsPage/StatisticsScreen";

import {
  expireTokenAction,
  refreshTokenAction,
} from "./Components/Actions/login";
import Profile from "./Components/Pages/Users/Profile";
import UpdateUser from "./Components/Pages/Users/UpdateUser";
import UserProfile from "./Components/Pages/Users/UserProfile";
import YourProfile from "./Components/Pages/Users/YourProfile";
import NotFound from "./Components/Pages/NotFound";
// import axios from "axios";
import ShowValues from "./Components/Pages/Fields&Sections/ShowValues";

import Hospital from "./Components/Pages/Hospital/Hospital";


const App = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const token = localStorage.getItem("token");


  
  // const cllAPi=()=>{
  //   axios.get("https://back_zad-main.test/api/ping").then((res) => {
  //     console.log(res.data);
  //   }).catch((err) => {
  //     console.log(err);
  //   });
  // }  

  const dispatch = useDispatch();

  const getUserAuth = useSelector((state) => state.getUserAuth);
  const { userAuth } = getUserAuth;
  const hasDispatched = useRef(false);

  useEffect(() => {
    if (!hasDispatched.current) {
      dispatch(refreshTokenAction());
      dispatch(expireTokenAction());
      hasDispatched.current = true;
    }
  }, [dispatch]);
  useEffect(() => {
    if (!userInfo && !token) {
      return;
    } else {
      dispatch(getUsersAuthAction());
    }
  }, [userInfo, dispatch]);
  
  return (
    <div>
      {/* <button onClick={cllAPi}>Call APi</button> */}
      <BrowserRouter>
        {userInfo && token ? (
          <React.Fragment>
            
            <div className="flex">
              <div className="">
                <Sidebar userAuth={userAuth} />
              </div>
              <div className="h-screen overflow-y-auto w-full overflow-x-hidden">
                <Navbar userAuth={userAuth} />

                <Routes>
                  <Route path="/" element={<Dashboard userAuth={userAuth} />} />
                  
                  <Route
                    path="/profile"
                    element={<Profile userAuth={userAuth} />}
                  />

                  <Route path="/patient" element={<Patient />} />
                  <Route path="/section" element={<SectionScreen />} />
                  <Route path="/medicalForm/:id" element={<MedicalForm />} />
                  <Route path="/showFields/:id" element={<ShowFields />} />
                  <Route path="/doctor" element={<Doctor />} />
                  <Route path="/surgery" element={<Surgery />} />
                  <Route path="/typeSurgery" element={<TypeSurgery />} />
                  <Route path="/organ" element={<Organ />} />
                  <Route path="/follow" element={<FollowUp />} />
                  <Route path="/reportMonthly" element={<ReportPage />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/users/create" element={<CreateUser />} />
                  <Route path="/users/update" element={<UpdateUser />} />
                  <Route
                    path="/users/profile/:userId"
                    element={<UserProfile />}
                  />
                  <Route
                    path="/yourProfile"
                    element={<YourProfile userAuth={userAuth} />}
                  />

                  <Route path="*" element={<NotFound />} />
                  <Route path="/showValues/:id" element={<ShowValues />} />

                  <Route path="/role" element={<RolePage />} />
                  <Route
                    path="/role/edit/:id/:roleName"
                    element={<EditRolePage />}
                  />

                  <Route
                    path="/followUpVisit/:id"
                    element={<FollowUpVisit />}
                  />

                  <Route path="/hospital" element={<Hospital />} />

                  <Route path="/statistics" element={<StatisticsScreen />} />
                  <Route path="/type/field/:id" element={<TypeFieldPage />} />
                  <Route path="/affiars" element={<AffiarsOfSurgeryPage />} />
                  <Route path="/help" element={<TypeOfHelp />} />
                  <Route
                    path="/type/field/dropdown/:id"
                    element={<TypeFieldDropdownValuePage />}
                  />
                  <Route
                    path="medicalSuplie"
                    element={<MedicalSupliesPage />}
                  />

                  <Route path="reject" element={<RejectPage />} />

                  <Route
                    path="/comeBackDoctor"
                    element={<ComeBackDoctorPage />}
                  />
                  <Route path="/whatsApp" element={<WhatsAppScreen />} />
                </Routes>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <Login />
        )}
      </BrowserRouter>
    </div>
  );
};

export default App;
